import { trackEvent, trackMetric } from '@mdvip/shared/lib/telemetry';
import { type Metric, onCLS, onFCP, onINP, onLCP, onTTFB } from 'web-vitals';

function sendToAnalytics(metric: Metric) {
  // Track as metric
  trackMetric(metric.name, metric.value, {
    id: metric.id,
    rating: metric.rating,
    navigationType: metric.navigationType,
  });

  // Also track as event for easier querying
  trackEvent(
    `WebVitals_${metric.name}`,
    {
      id: metric.id,
      rating: metric.rating,
      navigationType: metric.navigationType,
    },
    {
      value: metric.value,
    },
  );
}

export function initializeWebVitals() {
  // Core Web Vitals
  onCLS(sendToAnalytics); // Cumulative Layout Shift
  onLCP(sendToAnalytics); // Largest Contentful Paint
  onINP(sendToAnalytics); // Interaction to Next Paint

  // Additional metrics
  onFCP(sendToAnalytics); // First Contentful Paint
  onTTFB(sendToAnalytics); // Time to First Byte

  // Web Vitals tracking initialized
}
